module.exports = __webpack_public_path__ + "img/26.93c6f71e.png";